var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.537 11.215L0.718994 21.521L11.515 31.828L22.31 42.135L24.375 40.069L26.44 38.004L17.563 29.775L8.68599 21.546L17.551 13.259L26.416 4.97197L24.385 2.94097L22.354 0.909973L11.537 11.215Z","fill":"white"}));
}

Chevron.defaultProps = {"width":"27","height":"43","viewBox":"0 0 27 43","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
